"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MangopayCard = void 0;
const type_graphql_1 = require("type-graphql");
let MangopayCard = class MangopayCard {
    ExpirationDate;
    Alias;
    CardType;
    CardProvider;
    Country;
    Product;
    BankCode;
    Active;
    Currency;
    Validity;
    UserId;
    Id;
    Tag;
    CreationDate;
    Fingerprint;
};
exports.MangopayCard = MangopayCard;
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "ExpirationDate", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Alias", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "CardType", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "CardProvider", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Country", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Product", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "BankCode", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Active", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Currency", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Validity", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "UserId", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Id", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Tag", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", Number)
], MangopayCard.prototype, "CreationDate", void 0);
__decorate([
    (0, type_graphql_1.Field)(),
    __metadata("design:type", String)
], MangopayCard.prototype, "Fingerprint", void 0);
exports.MangopayCard = MangopayCard = __decorate([
    (0, type_graphql_1.ObjectType)("MangopayCard")
], MangopayCard);
//# sourceMappingURL=MangopayCard.js.map